import axios from "axios";
import Request from "./index";
import { auth } from "../lib/firebase";
import {
  signInWithPopup,
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  signOut,
  updateProfile,
  sendPasswordResetEmail,
} from "firebase/auth";

const API_KEY = process.env.REACT_APP_API_KEY;
//Register with custom API
// export const signupWithEmailAndPass = async (
//   email,
//   password,
//   firstName,
//   lastName
// ) => {
//   const apiUrl = `${REACT_APP_API_HOST}signUp`;
//   return new Promise((resolve, reject) => {
//     axios
//       .post(apiUrl, {
//         email,
//         password,
//         firstName,
//         lastName,
//       })
//       .then((response) => {
//         resolve(response);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// };

export const signupWithEmailAndPass = async (
  email,
  password,
  firstName,
  lastName
) => {
  return new Promise((resolve, reject) => {
    createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        return updateProfile(user, {
          displayName: `${firstName} ${lastName}`,
        }).then(() => {
          const expiryDate = new Date(user.stsTokenManager.expirationTime);
          localStorage.setItem(
            "refreshToken",
            user.stsTokenManager.refreshToken
          );
          localStorage.setItem("accessToken", user.accessToken);
          localStorage.setItem("expiresAt", expiryDate.toLocaleString());
          resolve(userCredential);
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
};

//Login with firebase fuction
export const signInWithPassword = async (email, password) => {
  const url = `${process.env.REACT_APP_IDENTITY_URL}:signInWithPassword?key=${API_KEY}`;
  return new Promise((resolve, reject) => {
    axios
      .post(url, {
        email,
        password,
        returnSecureToken: true,
      })
      .then((response) => {
        const expiresInInSeconds = parseInt(response.data.expiresIn, 10);
        const currentTime = Date.now();
        const expirationTime = currentTime + expiresInInSeconds * 1000;
        const expiryDate = new Date(expirationTime);
        localStorage.setItem("accessToken", response.data.idToken);
        localStorage.setItem("refreshToken", response.data.refreshToken);
        localStorage.setItem("expiresAt", expiryDate);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

//Register/Login with Google Auth
export const authWithGoogle = () => {
  return new Promise((resolve, reject) => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
      .then((result) => {
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const user = result.user;
        const expiryDate = new Date(user.stsTokenManager.expirationTime);
        const expiryDateString = expiryDate.toLocaleString();
        localStorage.setItem("refreshToken", user.stsTokenManager.refreshToken);
        localStorage.setItem("accessToken", user.accessToken);
        localStorage.setItem("expiresAt", expiryDateString);
        resolve(result);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        reject(error);
      });
  });
};

//Signout
export const logOut = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("expiresAt");
  return true;
};

export const getUser = () => {
  return new Promise((resolve, reject) => {
    Request.get("/getUser")
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const signupCreateUserQuota = () => {
  return new Promise((resolve, reject) => {
    Request.get("/signupCreateUserQuota")
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// Password Reset Function
export const resetPassword = async (email) => {
  return new Promise((resolve, reject) => {
    sendPasswordResetEmail(auth, email)
      .then(() => {
        resolve("Password reset email sent!");
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const validateEmail = async (email) => {
  return new Promise((resolve, reject) => {
    const payload = { email: email };
    Request.post("/validateEmail", payload)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
